import { CurrencyPipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig } from '@angular/router';
import Lara from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { PolicyMediator } from './app/http-services/mediators/policy.mediator';
import { PolicyDataService } from './app/http-services/services/policy-data.service';
import { httpInterceptorFn } from './app/shared/services/http-interceptor.service';
import { LoggingService } from './app/shared/services/logging.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptorFn])),
    PolicyMediator,
    PolicyDataService,
    LoggingService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false,
          cssLayer: true,
        },
      },
    }),
    provideRouter(
      appRoutes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    CurrencyPipe,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],
});
